import { render, staticRenderFns } from "./NewsAndEventDialog.vue?vue&type=template&id=340ace30&"
import script from "./NewsAndEventDialog.vue?vue&type=script&lang=ts&"
export * from "./NewsAndEventDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports